import { render, staticRenderFns } from "./PatentClassificationInfo.vue?vue&type=template&id=46e07836"
import script from "./PatentClassificationInfo.vue?vue&type=script&lang=js"
export * from "./PatentClassificationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports